module.exports = __webpack_public_path__ + "img/Speaker=Tianyu Guo.88851ea6.png";